import { render, staticRenderFns } from "./ProductPageDisplay.vue?vue&type=template&id=e581ae48&"
import script from "./ProductPageDisplay.vue?vue&type=script&lang=js&"
export * from "./ProductPageDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports